import type { ValidationErrorsMap } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import {
  getAgentSchema,
  offlineStoreDataGuard,
  type StoreData,
} from '../../model';

function getOfflinePosIds(pointsOfSales: StoreData[] | undefined): string[] {
  if (!Array.isArray(pointsOfSales)) return [];

  return pointsOfSales
    .filter(offlineStoreDataGuard)
    .map((store) => store.details.uiId);
}

function getAgentUiKey(item: unknown, index: number): string {
  const agent = item as { uiId?: string; id?: string } | null | undefined;
  const key = agent?.uiId ?? agent?.id;
  return (typeof key === 'string' && key) || `${index}`;
}

export function validateAgents(
  value: unknown,
  context: { pointsOfSales?: StoreData[] },
  shouldSkipEmpty = true
): ValidationErrorsMap {
  const offlinePosIds = getOfflinePosIds(context?.pointsOfSales);

  if (!Array.isArray(value) || value.length === 0) {
    if (shouldSkipEmpty || !offlinePosIds.length) {
      return {};
    }

    return {
      general: [{ message: 'Empty agents', path: [] }],
    };
  }

  const agentSchemaWithPosIds = getAgentSchema(offlinePosIds);

  const errors: ValidationErrorsMap = {};

  for (let i = 0; i < value.length; i++) {
    const result = agentSchemaWithPosIds.safeParse(value[i]);
    if (!result.success) {
      const uiKey = getAgentUiKey(value[i], i);
      errors[uiKey] = zodIssuesToValidationErrors(result.error.issues);
    }
  }

  return errors;
}
